import React from 'react'
import { AiOutlineCloseCircle } from 'react-icons/ai'
import RequestSenderIdForm from '../sms/RequestSenderIdForm'

const SMSSenderModal = ({ isOpen, setIsOpen }) => {
  if (!isOpen) return null

  const handleSuccess = () => {
    sessionStorage.setItem('sms_modal_dismissed', 'true')
    setIsOpen(false)
    window.location.reload()
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[99999] backdrop-blur-md p-4">
      <div className="bg-white dark:bg-dark rounded-lg shadow-lg w-full max-w-[480px] relative">
        <button
          onClick={() => {
            sessionStorage.setItem('sms_modal_dismissed', 'true')
            setIsOpen(false)
          }}
          className="absolute top-4 right-4 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 z-10"
        >
          <AiOutlineCloseCircle className="h-7 w-7" />
        </button>

        <div className="p-4 pt-12">
          <RequestSenderIdForm onSuccess={handleSuccess} compact />
        </div>
      </div>
    </div>
  )
}

export default SMSSenderModal
